import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Logo } from '../components/Logo';
import { useLanguage } from '../lib/LanguageContext';

export default function ForgotPassword() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      toast.success(t('auth.resetSent'));
      setStep(2);
    } catch (e) { toast.error(e?.response?.data?.detail || t('common.operationError')); } finally { setLoading(false); }
  };
  const reset = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post('/auth/reset-password', { email, code, new_password: newPwd });
      toast.success(t('auth.passwordReset'));
      setStep(3);
    } catch (e) { toast.error(e?.response?.data?.detail || t('common.operationError')); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-xl border border-slate-200">
        <Logo />
        <h1 className="text-2xl font-bold mt-6">{t('auth.forgotTitle')}</h1>
        {step === 1 && (
          <form onSubmit={sendCode} className="mt-6 space-y-4">
            <div><Label>{t('common.email')}</Label><Input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required/></div>
            <Button type="submit" disabled={loading} className="w-full bg-blue-700">{loading ? '...' : t('auth.resetLink')}</Button>
          </form>
        )}
        {step === 2 && (
          <form onSubmit={reset} className="mt-6 space-y-4">
            <div><Label>{t('auth.resetCodeLabel')}</Label><Input value={code} onChange={(e)=>setCode(e.target.value)} required/></div>
            <div><Label>{t('auth.newPassword')}</Label><Input type="password" value={newPwd} onChange={(e)=>setNewPwd(e.target.value)} required/></div>
            <Button type="submit" disabled={loading} className="w-full bg-blue-700">{loading ? '...' : t('auth.resetAction')}</Button>
          </form>
        )}
        {step === 3 && (
          <div className="mt-6 space-y-4">
            <p className="text-emerald-700">{t('auth.passwordChanged')}</p>
            <Link to="/connexion"><Button className="w-full bg-blue-700">{t('common.login')}</Button></Link>
          </div>
        )}
        <div className="mt-6 text-center text-sm"><Link to="/connexion" className="text-blue-700 hover:underline">{t('auth.backToLogin')}</Link></div>
      </div>
    </div>
  );
}
